import script from "./SaveAsDraftConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveAsDraftConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./SaveAsDraftConfirmationModal.vue?vue&type=style&index=0&id=04a36a46&lang=scss"

export default script